import React, { useMemo } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { get } from 'lodash';
import { enumT } from '../../../../../utils/helper';
import { Help } from '@mui/icons-material';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

const MUISelectField: React.FC<MUIFieldProps> = (props) => {
	const { label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, printMode, ...restProps } = props;

	// Normalize current value for comparisons
	const currentValue = typeof fieldValue === 'object' ? get(fieldValue, 'id', '') : fieldValue;
	const options = get(props, 'options', []);
	const enumList = get(props, 'enum', []);

	const printValue = useMemo(() => {
		// Try to resolve label from options first
		if (options && options.length > 0) {
			const match = options.find((opt: any) => {
				const optValue = get(opt, 'value') !== undefined ? get(opt, 'value') : opt;
				return optValue === currentValue;
			});
			if (match) {
				if (get(match, 'label')) {
					return get(match, 'label');
				} else {
					return enumT(currentValue);
				}
			}
		}

		// Try enum list
		if (enumList && enumList.length > 0) {
			const match = enumList.find((ele: any) => ele === currentValue);
			if (match) {
				return enumT(currentValue);
			}
		}
		return currentValue || '—';
	}, [currentValue, options, enumList]);

	// Render as plain text in print mode
	if (printMode) {
		return (
			<Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
				{printValue || '—'}
			</Box>
		);
	}

	return (
		<TextField
			select
			label={
				tooltip ? (
					<>
						<>{label}</>
						<MUIToolTip title={tooltip}>
							{' '}
							<Help fontSize="small" color="primary" sx={{ ml: '5px' }} />{' '}
						</MUIToolTip>
					</>
				) : (
					<>{label}</>
				)
			}
			value={typeof fieldValue === 'object' ? (get(props, 'options', []).length > 0 ? fieldValue.id : '') : fieldValue}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={errorMessage}
			fullWidth
			{...restProps}
		>
			{get(props, 'options', []).length > 0
				? get(props, 'options', []).map((ele: any, i: number) => {
					if (get(ele, 'label')) {
						return (
							<MenuItem key={i} value={get(ele, 'value')}>
								{get(ele, 'label')}
							</MenuItem>
						);
					} else {
						return (
							<MenuItem key={i} value={ele}>
								{enumT(ele)}
							</MenuItem>
						);
					}
				})
				: get(props, 'enum', []).map((ele: string, i: number) => (
					<MenuItem key={i} value={ele}>
						{enumT(ele)}
					</MenuItem>
				))}
		</TextField>
	);
};

export default MUISelectField;